import Head from 'next/head';
import Modal from '../components/Modal'
import Script from 'next/script';
import { useEffect, useLayoutEffect } from 'react';
import { useRouter } from 'next/router';
import { wrapper } from '../store';
import ScrollAnimation from '@/components/ScrollAnimation';
import Seo from '@/components/Seo';

import '@/styles/Actividad.scss';
import '@/styles/ActivitiesGrid.scss';
import '@/styles/ActivitiesSlider.scss';
import '@/styles/ActivityFeatures.scss';
import '@/styles/ActivityFirstDetails.scss';
import '@/styles/ActivityPrice.scss';
import '@/styles/ActivityHead.scss';
import '@/styles/activityList.scss';
//
import '@/styles/Advice.scss';
import '@/styles/BgMoving.scss';
import '@/styles/Booking.scss';
import '@/styles/bottomBar.scss';
import '@/styles/Button.scss';
import '@/styles/CampGlass.scss';
import '@/styles/CampsDescription.scss';
import '@/styles/Card.scss';
import '@/styles/CenefaTitulo.scss';
import '@/styles/Contacto.scss';
import '@/styles/ContactWays.scss';
import '@/styles/CookiesBar.scss';
import '@/styles/Error.scss';
import '@/styles/Faq.scss';
import '@/styles/FaqItem.scss';
import '@/styles/Footer.scss';
import '@/styles/GButton.scss';
import '@/styles/Header.scss';
import '@/styles/home.scss';
import '@/styles/input.scss';
import '@/styles/inScene.scss';
import '@/styles/ItemProject.scss';
import '@/styles/Localizacion.scss';
import '@/styles/Menu.scss';
import '@/styles/Modal.scss';
import '@/styles/ModalViewer.scss';
import '@/styles/NotAllow.scss';
import '@/styles/NotFound.scss';
import '@/styles/outScene.scss';
import '@/styles/Page.scss';
import '@/styles/Pagination.scss';
import '@/styles/PictureCeil.scss';
import '@/styles/PictureGrid.scss';
import '@/styles/quienessomos.scss';
import '@/styles/Randomllax.scss';
import '@/styles/RomboLogo.scss';
import '@/styles/sectionsMenu.scss';
import '@/styles/slick-theme.css';
import '@/styles/slick.css';
import '@/styles/Sticky.scss';
import '@/styles/svgCourtain.scss';
import '@/styles/Webcams.scss';



import '@/styles/CheckBox.scss';
import '@/styles/CkEditorInput.scss';
import '@/styles/customProperties.scss'
import '@/styles/animations.scss';
import '@/styles/uxux.scss'
import '@/styles/fonts.scss'

const useIsomorphicLayoutEffect = typeof window !== 'undefined'
  ? useLayoutEffect
  : useEffect;

function App({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    window.saveSize = () => {
      const currentSize = window.getSize();
      if (!(window.size) || (window.size.w !== currentSize.w)) {
        window.size = currentSize;
        return true;
      }
      return false;
    }
  }, [])

  useIsomorphicLayoutEffect(() => {
    const scrollAnimation = new ScrollAnimation({
      delay: 0.15,
      duration: 0.5,
    });
    scrollAnimation.init();

    return () => scrollAnimation.destroy();
  }, [router.asPath]);

  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width, viewport-fit=cover" />
      </Head>
      <Seo seo={pageProps.seo} />
      <Script src="/motio.min.js" />
      <Component {...pageProps} />
      <Modal />
    </>
  )
}

export default wrapper.withRedux(App)
